import React, {Component, useState, useEffect} from 'react'

import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'

interface Props {
  sort: string
  direction: string
  columns?: any
  onUpdate?: (sort: string, direction: string) => void
  sticky?: boolean
  stickyTop?: string
}

const TableHeader: React.FC<Props> = (props: any) => {
  const {sort: propsSort, direction: propsDirection, sticky, stickyTop} = props

  const [sort, setSort] = useState(propsSort)
  const [direction, setDirection] = useState(propsDirection)

  useEffect(() => {
    setSort(propsSort)
    setDirection(propsDirection)
  }, [propsSort, propsDirection])

  const headerClicked = (sort: any) => {
    const {onUpdate} = props

    var newDirection = direction === 'desc' ? 'asc' : 'desc'
    setDirection(newDirection)
    setSort(sort)

    if (onUpdate) onUpdate(sort, newDirection)
  }

  const {columns} = props

  return (
    <thead
      style={
        sticky
          ? {
              position: 'sticky',
              top: stickyTop || '0',
              zIndex: 99,
              backgroundColor: 'white',
            }
          : undefined
      }
    >
      <tr className='fw-bolder text-muted bg-light'>
        {columns
          .filter((f: any) => !f.disabled)
          .map((item: any, idx: any) => (
            <th
              key={item.name + '-' + idx}
              className={item.static ? '' : 'clickable'}
              style={
                item.width ? {width: `${item.width}%`, borderTop: 'none'} : {borderTop: 'none'}
              }
              onClick={() => {
                if (!item.static) headerClicked(item.sort)
              }}
            >
              <span style={{paddingLeft: '5px'}}></span>
              {item.name}
              {!item.static && item.sort === sort && (
                <span>
                  &nbsp;
                  {direction === 'desc' && (
                    <img src={toAbsoluteUrl('/media/icons/duotune/arrows/arr072.svg')} />
                  )}
                  {direction !== 'desc' && (
                    <img src={toAbsoluteUrl('/media/icons/duotune/arrows/arr073.svg')} />
                  )}
                </span>
              )}
            </th>
          ))}
      </tr>
    </thead>
  )
}

export {TableHeader}
